<div class="myvf-alert-overlay">
  <div class="myvf-alert-dialog">
    <div class="myvf-alert-dialog-inner">
      <div class="myvf-alert-dialog-header"
        [ngStyle]="{ 'backgroundColor': headerColor}">
        <div *ngIf="icon" class="icon"><img [src]="icon" /></div>
        <div class="title" [ngClass]="{'with-icon': icon}">{{ title }}</div>
      </div>
      <div class="myvf-alert-dialog-body">
        <ng-content></ng-content>
      </div>
      <div class="myvf-alert-dialog-footer" *ngIf="serviceNotify">
        <button myvf-ui-button btnOutlineDark btnStraight *ngIf="showRetryButton" (click)="handleRetry()">{{ retryLabel }}</button>
        <button myvf-ui-button btnOutlineDark btnStraight *ngIf="showCloseButton" (click)="handleClose()">{{ closeLabel }}</button>
      </div>
    </div>
  </div>
</div>
